<template>
<div class="wpcm-wrapper">
  <div :class="`donation-style-${dstyle} ${store.config.wrapper_class}`">
    <div class="el-dialog__header" :style="{backgroundImage: `url(${store.config.background_image})`}"></div>
    <div class="dialog-content" v-loading="store.loading">
      <modal-template v-if="store.components || (store.use_form_builder && store.form_builder_config)" :config="store.config" :currentStep="store.step">
        <template v-for="(slotData, slot) in groupBySlots(store.components)" v-slot:[`${slot}`]>
          <template v-for="comp in slotData">
            <modal-view :comp="comp"></modal-view>
          </template>
        </template>
      </modal-template>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';
import descriptor from '../utils/rules'
import ModalView from "./ModalView.vue";
import ModalTemplate from "./ModalTemplate.vue";
import { groupBySlots } from '../utils/helper';

const store = useDonationFormsStore();
const props = defineProps(['id', 'dstyle']);
const _ = globalThis._;

const submit = () => {
  const { $state } = store;
    store.validate({ rules: descriptor, fields: $state })
    .then((res) => {
      store.submit()
    })
    .catch(({fields, errors}) => {
      validation_catch(fields, errors);
    });
};
const validation_catch = (fields, errors) => {
  _.each(fields, (field) => {
    setTimeout(() => {
      ElNotification({
        type: 'error',
        title: "Error",
        message: field[0].message,
        offset: 40,
      });
    }, 300);
  });
};

onMounted(() => {
  store.getData({ vm: props });
    if (store.showModal) {

    }
});


</script>
